import { User } from './User';

export class ExtendedUser extends User {
  removable: boolean;

  relationToUser: string;

  constructor({
    removable,
    relationToUser,
    ...userProps
  }: Record<string, any>) {
    super(userProps);
    this.removable = removable;
    this.relationToUser = relationToUser;
  }
}

export const EmptyExtendedUser: ExtendedUser = {
  userID: '',
  alias: '',
  owner: '',
  firstName: '',
  lastName: '',
  displayName: '',
  userName: '',
  removable: false,
  relationToUser: '',
  homeRegion: '',
};
